import moment from "moment";
import { defineComponent } from "vue";
import $ from "jquery";

export default defineComponent({
    props: {
        modelValue: {
            type: String,
            default: ""
        },
        minTime: {
            type: String,
            default: "12:00 AM"
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    emits: ["update:modelValue"],

    data() {
        return {
            timepicker: null as any
        };
    },

    mounted() {
        this.initializeTimePicker();
    },

    watch: {
        modelValue(newValue: string) {
            if (!this.timepicker) {
                return;
            }

            const current = $(this.$refs.input as HTMLInputElement).val();

            if (current !== newValue) {
                $(this.$refs.input as HTMLInputElement).val(newValue);
            }
        },
        minTime(newValue: string) {
            if (!this.timepicker) {
                return;
            }

            ($(this.$refs.input as HTMLInputElement) as any).timepicker("option", "minTime", newValue || "12:00 AM");
        }
    },

    methods: {
        initializeTimePicker() {
            const input = this.$refs.input as HTMLInputElement;
            const $input = $(input);

            this.timepicker = ($input as any).timepicker({
                interval: 15,
                minTime: this.minTime || "12:00 AM",
                forceRoundTime: false,
                scrollDefault: this.modelValue || this.minTime || "12:00 AM",
                change: (time: Date) => {
                    if (time) {
                        const formatted = moment(time).format("hh:mm A");

                        if (formatted !== this.modelValue) {
                            this.$emit("update:modelValue", formatted);
                        }
                    }
                }
            });

            if (this.modelValue) {
                $input.val(this.modelValue);
            }

            $input.on("change.timepicker-vue", () => {
                const value = $input.val()?.toString() || "";
                if (value! == this.modelValue) {
                    this.$emit("update:modelValue", value);
                }
            });
        }
    },

    beforeUnmount() {
        if (this.timepicker) {
            ($(this.$refs.input as HTMLElement) as any).off(".timepicker-vue").timepicker("destroy");

            this.timepicker = null;
        }
    }
});
